import React, { Fragment, useState } from "react";
import { projectApp, projectWeb } from "../data";

const Works = () => {
  const [activeTag, setActiveTag] = useState("apps_tag");

  const changeProjectTag = (tag) => {
    setActiveTag(tag);
  };

  return (
    <section className="worksection add_zindex">
      <div id="Projects" className="first1"></div>
      <h2 className="mx-auto mb-3 underline work__topic" data-aos="fade-down">
        Projects
      </h2>
      <div id="tag" className="mb-3" data-aos="fade-down">
        <h4
          className={`tag__item apps_tag ${
            activeTag === "apps_tag" ? "selected" : ""
          }`}
          onClick={() => changeProjectTag("apps_tag")}
        >
          App
        </h4>
        <h4
          className={`tag__item web__tag ${
            activeTag === "web__tag" ? "selected" : ""
          }`}
          onClick={() => changeProjectTag("web__tag")}
        >
          Website
        </h4>
      </div>

      {projectApp.map((itm, index) => (
        <div
          key={index}
          className={`work__container tag__item apps_tag ${
            activeTag === "apps_tag" ? "selected" : ""
          }`}
        >
          <div className="work_title" data-aos="fade-down">
            <h4>{itm.title}</h4>
          </div>
          {itm.data.map((item, itemIndex) => (
            <div key={itemIndex} className="video_outer_frame">
              <video className="video__frame" controls data-aos="fade-left">
                <source src={item.url} type="video/mp4" />
              </video>
              <ul className="project_links">
                {item.links.map((link, linkIndex) => (
                  <a
                    key={linkIndex}
                    target="_blank"
                    href={link.url}
                    rel="noopener noreferrer"
                  >
                    <li className={link.icon}></li>
                  </a>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}

      <div
        className={`work__container tag__item row web__tag ${
          activeTag === "web__tag" ? "selected" : ""
        }`}
      >
        {projectWeb.map((itm, index) => (
          <Fragment key={index}>
            <div className="work_title" data-aos="fade-down">
              <h4>{itm.title}</h4>
            </div>
            {itm.data.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className="p-1 text-black border-0 card col-xxl-3 col-xl-4 col-md-6 col-xs-12 demo"
                data-aos="fade-down"
              >
                <a
                  target="_blank"
                  href={item.projectLink}
                  rel="noopener noreferrer"
                >
                  <img
                    src={item.projectImg}
                    className="card-img"
                    alt={item.title}
                  />
                  <div className="bottom-left">
                    <h5 className="card-title1">{item.title}</h5>
                  </div>
                  <div className="card-img-overlay">
                    <h5 className="card-title">{item.title}</h5>
                    <p className="card-text">{item.desc}</p>
                    <div className="text-center">
                      <i className="fa fa-link"></i>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </section>
  );
};

export default Works;
